@if (modal) {
  <app-confirm-modal-template [modal]="modal">
    <div preModalBody class="meta-bar px-3 py-2">
      <div class="container">
        <div class="row">
          @if (roster) {
            <div class="col-auto py-2">
              <div class="title">{{ roster.name }}</div>
              <div class="sub-title">
                @if (roster.source === uploadFileTypes.Manual) {
                  <span> {{ 'MANUAL' | translate }}</span>
                }
                @if (roster.source === uploadFileTypes.Automatic) {
                  <span> {{ 'SERVER_FILE' | translate }}</span>
                }
                @if (roster.source === uploadFileTypes.GroupOfGroups) {
                  <span> {{ 'GROUP_OF_GROUPS' | translate }}</span>
                }
              </div>
            </div>
          }
          <div class="col-auto ml-auto py-2 text-right">
            <span class="d-flex align-items-center ml-auto">
              <i class="ftmi-group icon"></i>
              {{ roster?.membershipCount }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div modalBody>
      <div class="mh-sm">
        <ul class="list-group">
          @for (item of roster?.membershipCollection; track item) {
            <li class="list-group-item">
              <b class="mr-3">{{ item?.user?.firstName }} {{ item?.user?.lastName }}</b>
              {{ item?.user?.email }}
            </li>
          }
        </ul>
      </div>
    </div>
  </app-confirm-modal-template>
}
